<div class="app-loader-backdrop fadeIn" *ngIf="showAppLoader">
  <div class="app-loader">
    <!-- <svg height="110" width="110">
      <circle cx="55" cy="55" r="50" />
    </svg> -->
    <img src="../images/loader-image.gif" width="180" alt="portr logo">
    <app-trust-pilot></app-trust-pilot>
  </div>
</div>
